import { IntroductionStylesVariant } from 'components/Introduction'

export interface GetIntroductionStylesVariantParams {
  isLightBackgroundVariant: boolean
  isSlimVariant: boolean
}

export const getIntroductionStylesVariant = ({
  isLightBackgroundVariant,
  isSlimVariant
}: GetIntroductionStylesVariantParams): IntroductionStylesVariant => {
  if (!isLightBackgroundVariant) {
    return IntroductionStylesVariant.LightBackgroundVariant
  }

  if (isSlimVariant) {
    return IntroductionStylesVariant.SlimVariant
  }

  return IntroductionStylesVariant.GreyBackground
}
